export default {
  ReceivePerson: 'Người nhận',
  FullName: 'Họ và tên',
  Address: 'Địa chỉ',
  Explain: 'Diễn giải',
  CTReference: 'CT tham chiếu',
  CTDate: 'Ngày CT',
  HTDate: 'Ngày HT',
  CTNumber: 'Số CT',
  PCDate: 'Ngày PC',
  PCNumber: 'Số PC',
  GBCNumber: 'Số GBC',
  SalaryPayment: 'Chi tiền gửi trả lương',
  SalaryPaymentNote: 'Phiếu chi trả lương',
  SummaryAmount: 'Tổng tiền',
  CommonInfo: 'Thông tin chung',
  Attach: 'Kèm theo',
  GenerateFromSalaGov: 'Sinh từ SalaGov',
  PayrollTreasuryTransfer: 'Chuyển khoản kho bạc chi lương',
  GRNumber: 'Số GR',
  CKCNumber: 'Số CKC',
};
